'use client';

import React, { useState, useEffect } from 'react';

const BreakpointIndicator = ({ className = '' }) => {
  const [breakpoint, setBreakpoint] = useState('');

  useEffect(() => {
    // Function to determine current breakpoint
    const determineBreakpoint = () => {
      const width = window.innerWidth;

      // Match these to your Tailwind config breakpoints
      if (width < 640) return 'xs';
      if (width < 768) return 'sm';
      if (width < 1024) return 'md';
      if (width < 1280) return 'lg';
      if (width < 1536) return 'xl';
      return '2xl';
    };

    // Set initial breakpoint
    setBreakpoint(determineBreakpoint());

    // Add resize listener
    const handleResize = () => {
      setBreakpoint(determineBreakpoint());
    };

    window.addEventListener('resize', handleResize);

    // Clean up
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      <div
        className='fixed bottom-4 left-14 flex size-10 items-center justify-center rounded-full border-[3px] border-white bg-black text-center font-bold uppercase text-white'
        style={{ zIndex: 999 }}
      >
        {breakpoint}
      </div>
    </>
  );
};

export default BreakpointIndicator;
